import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Naming the Voice",
    opening: localizedGenderNode(
      [
      "Today I notice the judging voice.",
      "I am not that voice.",
      "I am here."
    ],
      [
      "Today I notice the judging voice.",
      "I am not that voice.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When does this voice show up?",
      "What words does it use?",
      "What do I feel afterward?"
    ],
      [
      "When does this voice show up?",
      "What words does it use?",
      "What do I feel afterward?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A voice is a voice, not me."
    ],
      [
      "A voice is a voice, not me."
    ]
    ),
    action: localizedGenderNode(
      "write one sentence - \"This is a voice, not truth\".",
      "write one sentence - \"This is a voice, not truth\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "The Trigger Moment",
    opening: localizedGenderNode(
      [
      "Today I notice the moment the judgment lights up.",
      "Just seeing it.",
      "I stay with myself."
    ],
      [
      "Today I notice the moment the judgment lights up.",
      "Just seeing it.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe in and out.",
      "One breath."
    ],
      [
      "I breathe in and out.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What happened right before the voice started?",
      "What does the voice say then?",
      "Where does it sit in my body?"
    ],
      [
      "What happened right before the voice started?",
      "What does the voice say then?",
      "Where does it sit in my body?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "In the first moment there is a small space."
    ],
      [
      "In the first moment there is a small space."
    ]
    ),
    action: localizedGenderNode(
      "one breath when the voice rises.",
      "one breath when the voice rises."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "The Body Under Judgment",
    opening: localizedGenderNode(
      [
      "Today I listen to my body when judgment rises.",
      "Not to fix it.",
      "I am here."
    ],
      [
      "Today I listen to my body when judgment rises.",
      "Not to fix it.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice my breath.",
      "One breath."
    ],
      [
      "I notice my breath.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where does my body hold the judgment?",
      "What does my body need in that moment?",
      "What could soften a little?"
    ],
      [
      "Where does my body hold the judgment?",
      "What does my body need in that moment?",
      "What could soften a little?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "The body is not guilty, it is just holding."
    ],
      [
      "The body is not guilty, it is just holding."
    ]
    ),
    action: localizedGenderNode(
      "a hand on my chest and one breath.",
      "a hand on my chest and one breath."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Story vs. Fact",
    opening: localizedGenderNode(
      [
      "Today I separate fact from story.",
      "Without fighting it.",
      "I stay with myself."
    ],
      [
      "Today I separate fact from story.",
      "Without fighting it.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe in and out.",
      "One breath."
    ],
      [
      "I breathe in and out.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is the simple fact here?",
      "What story jumped in?",
      "What softer possibility could also be true?"
    ],
      [
      "What is the simple fact here?",
      "What story jumped in?",
      "What softer possibility could also be true?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A story is not me."
    ],
      [
      "A story is not me."
    ]
    ),
    action: localizedGenderNode(
      "an inner sentence - \"This is interpretation\".",
      "an inner sentence - \"This is interpretation\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "What the Voice Tries to Do",
    opening: localizedGenderNode(
      [
      "Today I check what the voice is trying to achieve.",
      "Without justifying it.",
      "I am here."
    ],
      [
      "Today I check what the voice is trying to achieve.",
      "Without justifying it.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I soften my shoulders a little.",
      "One breath."
    ],
      [
      "I soften my shoulders a little.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is the voice trying to protect me from?",
      "What is it afraid of?",
      "What price am I paying?"
    ],
      [
      "What is the voice trying to protect me from?",
      "What is it afraid of?",
      "What price am I paying?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "If it tries to protect, I can also see the cost."
    ],
      [
      "If it tries to protect, I can also see the cost."
    ]
    ),
    action: localizedGenderNode(
      "one sentence of understanding.",
      "one sentence of understanding."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "An Old Voice",
    opening: localizedGenderNode(
      [
      "Today I check if this is an old voice.",
      "Not to dig deep.",
      "I am here."
    ],
      [
      "Today I check if this is an old voice.",
      "Not to dig deep.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice my feet.",
      "One breath."
    ],
      [
      "I notice my feet.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Who does this voice sound like?",
      "When have I heard it before?",
      "What did I need back then?"
    ],
      [
      "Who does this voice sound like?",
      "When have I heard it before?",
      "What did I need back then?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "If it is an old voice, I can hold it gently."
    ],
      [
      "If it is an old voice, I can hold it gently."
    ]
    ),
    action: localizedGenderNode(
      "say in my heart \"This is an old voice\" once.",
      "say in my heart \"This is an old voice\" once."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "The Cost",
    opening: localizedGenderNode(
      [
      "Today I see the cost of the judgment.",
      "Without punishment.",
      "I stay with myself."
    ],
      [
      "Today I see the cost of the judgment.",
      "Without punishment.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my sitting.",
      "One breath."
    ],
      [
      "I feel my sitting.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What does this judgment take from me?",
      "What part of me gets smaller?",
      "What would I like to return to myself?"
    ],
      [
      "What does this judgment take from me?",
      "What part of me gets smaller?",
      "What would I like to return to myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Seeing the cost is a step of compassion."
    ],
      [
      "Seeing the cost is a step of compassion."
    ]
    ),
    action: localizedGenderNode(
      "write one word about what I return to myself.",
      "write one word about what I return to myself."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "A Small Compassion",
    opening: localizedGenderNode(
      [
      "Today I try to speak to myself gently.",
      "Not perfect, just a little.",
      "I am here."
    ],
      [
      "Today I try to speak to myself gently.",
      "Not perfect, just a little.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I soften my jaw.",
      "One breath."
    ],
      [
      "I soften my jaw.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How would I speak to a friend here?",
      "What soft sentence do I need to hear?",
      "What shifts in me when I hear it?"
    ],
      [
      "How would I speak to a friend here?",
      "What soft sentence do I need to hear?",
      "What shifts in me when I hear it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One gentle word can change the tone."
    ],
      [
      "One gentle word can change the tone."
    ]
    ),
    action: localizedGenderNode(
      "one soft sentence to myself.",
      "one soft sentence to myself."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "An Inner Boundary",
    opening: localizedGenderNode(
      [
      "Today I set a boundary with the cruel voice.",
      "Quietly.",
      "I am here."
    ],
      [
      "Today I set a boundary with the cruel voice.",
      "Quietly.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my back supported.",
      "One breath."
    ],
      [
      "I feel my back supported.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Which sentences are too much for me?",
      "What boundary do I want to set?",
      "How do I say it to myself?"
    ],
      [
      "Which sentences are too much for me?",
      "What boundary do I want to set?",
      "How do I say it to myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "An inner boundary is protection, not a war."
    ],
      [
      "An inner boundary is protection, not a war."
    ]
    ),
    action: localizedGenderNode(
      "say \"I do not speak to myself like that\".",
      "say \"I do not speak to myself like that\"."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "A Request to Myself",
    opening: localizedGenderNode(
      [
      "Today I give myself one clear request.",
      "Without punishment.",
      "I stay with myself."
    ],
      [
      "Today I give myself one clear request.",
      "Without punishment.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "One breath."
    ],
      [
      "I breathe slowly.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is my most important request right now?",
      "How do I say it in one sentence?",
      "What am I willing to give myself in return?"
    ],
      [
      "What is my most important request right now?",
      "How do I say it in one sentence?",
      "What am I willing to give myself in return?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One request can soften the day."
    ],
      [
      "One request can soften the day."
    ]
    ),
    action: localizedGenderNode(
      "write the request in a short sentence.",
      "write the request in a short sentence."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "A New Sentence",
    opening: localizedGenderNode(
      [
      "Today I choose a new sentence for myself.",
      "Small and simple.",
      "I am here."
    ],
      [
      "Today I choose a new sentence for myself.",
      "Small and simple.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice my inner voice.",
      "One breath."
    ],
      [
      "I notice my inner voice.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What new sentence do I want to say to myself?",
      "When did I most need to hear it?",
      "How does it feel when I say it?"
    ],
      [
      "What new sentence do I want to say to myself?",
      "When did I most need to hear it?",
      "How does it feel when I say it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A new sentence creates a small space."
    ],
      [
      "A new sentence creates a small space."
    ]
    ),
    action: localizedGenderNode(
      "say the sentence once.",
      "say the sentence once."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Repair After a Slip",
    opening: localizedGenderNode(
      [
      "Today I learn to return to myself after a slip.",
      "Without punishment.",
      "I am here."
    ],
      [
      "Today I learn to return to myself after a slip.",
      "Without punishment.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When does the voice return after a mistake?",
      "What helps me return to myself?",
      "What repair sentence do I want to say?"
    ],
      [
      "When does the voice return after a mistake?",
      "What helps me return to myself?",
      "What repair sentence do I want to say?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Repair is a gentle return, not erasing."
    ],
      [
      "Repair is a gentle return, not erasing."
    ]
    ),
    action: localizedGenderNode(
      "one short repair sentence.",
      "one short repair sentence."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A Small Practice",
    opening: localizedGenderNode(
      [
      "Today I choose a small steady practice.",
      "Not big.",
      "I am here."
    ],
      [
      "Today I choose a small steady practice.",
      "Not big.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my sitting.",
      "One breath."
    ],
      [
      "I feel my sitting.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small practice will help me stay steady?",
      "When in the day can I do it?",
      "What will gently remind me?"
    ],
      [
      "What small practice will help me stay steady?",
      "When in the day can I do it?",
      "What will gently remind me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small practice builds a new voice."
    ],
      [
      "A small practice builds a new voice."
    ]
    ),
    action: localizedGenderNode(
      "choose one moment for the practice.",
      "choose one moment for the practice."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Gentle Closure",
    opening: localizedGenderNode(
      [
      "Today I close the journey gently.",
      "Without forcing a perfect ending.",
      "I am here."
    ],
      [
      "Today I close the journey gently.",
      "Without forcing a perfect ending.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about this voice?",
      "What is the early sign it returns?",
      "Return sentence for the moment before - what do I say to myself?"
    ],
      [
      "What did I learn about this voice?",
      "What is the early sign it returns?",
      "Return sentence for the moment before - what do I say to myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I can be accurate without cruelty."
    ],
      [
      "I can be accurate without cruelty."
    ]
    ),
    action: localizedGenderNode(
      "one breath before responding.",
      "one breath before responding."
    ),
  },
].map(buildNormalizedDay);

export const cruelSelfJudgmentBlueprintEn = buildNormalizedPilotBlueprint({
  id: "cruel_self_judgment_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "cruel_self_judgment",
  category: "self_worth",
  journeyName: {
    he: "שיפוט עצמי אכזרי (איך שוב עשיתי את זה)",
    en: "Cruel self-judgment (How did I do it again)",
    es: "Juicio propio cruel (¿Cómo lo hice otra vez?)",
  },
  days,
});

export default cruelSelfJudgmentBlueprintEn;
